import Vue from 'vue'

class OrganizationPerimeterRepository {

  // PERIMETERS
  searchPerimeters(searchText, offset = 0, limit = 20, orderBy = 'name', orderDirection = 'asc') {
    return new Promise((resolve, reject) => {
      Vue.auth.fetch({
        url: '/api/organization/perimeter/search',
        method: 'post',
        data: { searchText, offset, limit, orderBy, orderDirection },
      })
      .then(response => resolve(response.data))
      .catch(err => reject(err))
    })
  }

  getPerimeter(perimeterId) {
    return new Promise((resolve, reject) => {
      Vue.auth.fetch({
        url: `/api/organization/perimeter/${perimeterId}`,
        method: 'get',
      })
      .then(response => resolve(response.data))
      .catch(err => reject(err))
    })
  }

  createPerimeter(data) {
    return new Promise((resolve, reject) => {
      Vue.auth.fetch({
        url: '/api/organization/perimeter',
        method: 'post',
        data,
      })
      .then(response => resolve(response.data))
      .catch(err => reject(err))
    })
  }

  updatePerimeter(perimeterId, data) {
    return new Promise((resolve, reject) => {
      Vue.auth.fetch({
        url: `/api/organization/perimeter/${perimeterId}`,
        method: 'put',
        data,
      })
      .then(response => resolve(response.data))
      .catch(err => reject(err))
    })
  }

  deletePerimeter(perimeterId) {
    return new Promise((resolve, reject) => {
      Vue.auth.fetch({
        url: `/api/organization/perimeter/${perimeterId}`,
        method: 'delete',
      })
      .then(response => resolve(response.data))
      .catch(err => reject(err))
    })
  }

  // SUB-PERIMETERS
  searchSubPerimeters(searchText, offset = 0, limit = 20, orderBy = 'name', orderDirection = 'asc', filters = {}) {
    return new Promise((resolve, reject) => {
      Vue.auth.fetch({
        url: '/api/organization/sub-perimeter/search',
        method: 'post',
        data: { searchText, offset, limit, orderBy, orderDirection, ...filters },
      })
      .then(response => resolve(response.data))
      .catch(err => reject(err))
    })
  }

  getSubPerimeter(subPerimeterId) {
    return new Promise((resolve, reject) => {
      Vue.auth.fetch({
        url: `/api/organization/sub-perimeter/${subPerimeterId}`,
        method: 'get',
      })
      .then(response => resolve(response.data))
      .catch(err => reject(err))
    })
  }

  createSubPerimeter(data) {
    return new Promise((resolve, reject) => {
      Vue.auth.fetch({
        url: '/api/organization/sub-perimeter',
        method: 'post',
        data,
      })
      .then(response => resolve(response.data))
      .catch(err => reject(err))
    })
  }

  updateSubPerimeter(subPerimeterId, data) {
    return new Promise((resolve, reject) => {
      Vue.auth.fetch({
        url: `/api/organization/sub-perimeter/${subPerimeterId}`,
        method: 'put',
        data,
      })
      .then(response => resolve(response.data))
      .catch(err => reject(err))
    })
  }

  deleteSubPerimeter(subPerimeterId) {
    return new Promise((resolve, reject) => {
      Vue.auth.fetch({
        url: `/api/organization/sub-perimeter/${subPerimeterId}`,
        method: 'delete',
      })
      .then(response => resolve(response.data))
      .catch(err => reject(err))
    })
  }

  // LINK / UNLINK
  linkSubPerimeterToPerimeter(subPerimeterId, perimeterId) {
    return new Promise((resolve, reject) => {
      Vue.auth.fetch({
        url: `/api/organization/sub-perimeter/${subPerimeterId}/perimeter/${perimeterId}`,
        method: 'put',
      })
      .then(response => resolve(response.data))
      .catch(err => reject(err))
    })
  }

  unlinkSubPerimeterFromPerimeter(subPerimeterId, perimeterId) {
    return new Promise((resolve, reject) => {
      Vue.auth.fetch({
        url: `/api/organization/sub-perimeter/${subPerimeterId}/perimeter/${perimeterId}`,
        method: 'delete',
      })
      .then(response => resolve(response.data))
      .catch(err => reject(err))
    })
  }
}

export default new OrganizationPerimeterRepository()
